import { Fragment } from "react";

function parseLine(raw) {
  const line = raw.trim();
  if (!line) return { type: "gap" };
  const tab = raw.indexOf("\t");
  const colon = line.lastIndexOf(":");
  let label = "", value = "";
  if (colon > 0 && colon < line.length - 1) {
    label = line.slice(0, colon).trim();
    value = line.slice(colon + 1).trim();
  } else if (tab > 0) {
    label = raw.slice(0, tab).trim();
    value = raw.slice(tab + 1).trim();
  }
  value = value.replace(/\s+/g, " ");
  if (label && value && !value.startsWith("//")) return { type: "row", label, value };
  return { type: "para", text: line };
}

function parse(text) {
  const items = [];
  for (const it of String(text || "").split(/\r?\n/).map(parseLine)) {
    if (it.type === "gap" && (!items.length || items[items.length - 1].type === "gap")) continue;
    items.push(it);
  }
  while (items.length && items[items.length - 1].type === "gap") items.pop();
  return items;
}

export const RichText = ({ text, lang, testId }) => {
  let first = true;
  const edge = (it) => {
    const cls = first || it.afterGap ? " rich-first" : "";
    first = false;
    return cls;
  };
  const items = parse(text);
  items.forEach((it, i) => { it.afterGap = i > 0 && items[i - 1].type === "gap"; });
  return (
    <div className="rich-grid" lang={lang} data-testid={testId}>
      {items.map((it, i) => {
        if (it.type === "gap") return <span key={i} className="rich-gap" />;
        const e = edge(it);
        if (it.type === "para") return <p key={i} className={`rich-para${e}`}>{it.text}</p>;
        return (
          <Fragment key={i}>
            <span className={`rich-label${e}`}>{it.label}</span>
            <span className={`rich-value${e}${it.value.length > 14 ? " rich-wrap" : ""}`} data-testid="rich-value"><bdi dir="auto">{it.value}</bdi></span>
          </Fragment>
        );
      })}
    </div>
  );
};
